import * as $18n from '@alife/lazada-i18n';
import React from 'react';
import { FileUploader } from './uploader';

export const Uploader = ({ form, onChange }) => {
  return (
    <div>
      <div className="auto-feedback-uploader-hint">
        <div
          dangerouslySetInnerHTML={{
            __html: /*#__PURE__*/$18n.get(
              'asc-fb.feedback-form.upload-tips-one',
              'You can upload images and video using the paste shortcut or drag and drop.'
            ),
          }}
        />
        <div
          dangerouslySetInnerHTML={{
            __html: /*#__PURE__*/$18n.get(
              'asc-fb.feedback-form.upload-tips-two',
              'The maximum supported is <span>50mb</span>, and any excess will be filtered'
            ),
          }}
        />
        <div
          dangerouslySetInnerHTML={{
            __html: /*#__PURE__*/$18n.get(
              'asc-fb.feedback-form.upload-tips-three',
              'Video recording supports <span>60s</span>'
            ),
          }}
        />
      </div>
      <FileUploader phone={form.getValuesIn('phone')} email={form.getValuesIn('email')} onFieldChange={onChange} />
    </div>
  );
};
